<template>
  <gift-pack-detail :is-create="false" />
</template>

<script>
import GiftPackDetail from './detail'
export default {
  name: 'EditGiftPackage',
  components: { GiftPackDetail }
}
</script>
